import { Typography } from '@navi/web-ui/lib/primitives';
import ActionContainer from './ActionContainer';
import { ActionType } from '../utils';
import styles from '../index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getActivePendingActions } from './actions';
import { RootState } from '@cp/src/store';

interface IPendingActionsProps {
  caseReferenceId: string;
  loanaccountnumber: string;
  customerreferenceid: string;
}

const PendingActions = (props: IPendingActionsProps) => {
  const { caseReferenceId, loanaccountnumber, customerreferenceid } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getActivePendingActions(caseReferenceId, loanaccountnumber, customerreferenceid));
  }, [loanaccountnumber]);

  const actionEvents = useSelector((state: RootState) => state.common.actionEvents) || [];

  const contactAction = actionEvents?.find?.(
    event => event.actionType === ActionType.UNATTEMPTED_NON_PRIMARY_NUMBERS
  );

  const hasContactActions = !!contactAction;
  const hasUnacknowledgedContact = !!contactAction?.unAcknowledged;

  if (!hasContactActions) {
    return null;
  }

  return (
    <>
      <div className="py-3 mx-6">
        <div className="items-center flex flex-row gap-4">
          <Typography variant="h4">{'Pending Actions'}</Typography>
          <div>
            <ActionContainer
              showNotificationDot={hasUnacknowledgedContact}
              actionReferenceId={contactAction?.actionReferenceId}
              actionLabel={contactAction?.actionLabel}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingActions;
